import phoneFormatter from 'phone-formatter';
import slugify from 'lodash.kebabcase';
import capitalize from 'lodash.capitalize';
import camelCase from 'lodash.camelcase';
import upperFirst from 'lodash.upperfirst';

export { camelCase, capitalize, slugify, upperFirst };

export function formatPhoneNumber(number: string | null) {
  return number ? phoneFormatter.format(number, '(NNN) NNN-NNNN') : '';
}

// Replaces the UTF-16 non breaking space character number 160
// with the regular space UTF-16 number 32
export const replaceNonBreakingSpaces = (stringInput?: string) =>
  stringInput?.replaceAll(' ', ' ');

export const isString = <T>(value: string | T): value is string =>
  typeof value === 'string';
